import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";

export default function FAQ() {
  const { t, pickL } = useI18n();
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <Seo title={t("home.faqTitle")} />
      <PageHero eyebrow="FAQ" title={t("home.faqTitle")} />
      <section className="container-x py-14 max-w-3xl">
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={f.id} className="surface overflow-hidden">
              <button onClick={() => setOpen(open === i ? null : i)} data-testid={`faq-${i}`}
                className="w-full flex items-center justify-between p-5 text-left font-medium">
                {pickL(f, "q")}
                <span className={`text-primary text-xl transition-transform ${open === i ? "rotate-45" : ""}`}>+</span>
              </button>
              {open === i && <div className="px-5 pb-5 text-sm text-muted-foreground">{pickL(f, "a")}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
